/* Viretta (owner 9 Oct: »check all images of products as they have a white frame around them«).
   Our packshots are shot on a very light grey ground (#F5F8F7 … #F7F7F7), not pure white, so a box in another colour shows
   as a frame around them. For every product-picture box below, the ground is read from the corners of a 40 px copy of the
   photo (Shopify's CDN allows it) and the box gets exactly that colour. Lifestyle photos (corners not light and even) are
   left alone. Runs again when the cart drawer, filters or »Vis alle« add pictures. */
(() => {
  if (window.VirettaV2Ground) return;
  window.VirettaV2Ground = true;
  const BOXES = ['.v2-card__media', '.v2-goes__img', '.v2-setrow__img', '.v2-up__img', '.v2-parts__img', '.v2-jrow__img',
    '.v2-cd-line__img', '.v2-cart__img', '.v2-cart__recimg', '.viretta-set-swap__media'];
  const SEL = BOXES.join(',');
  const cache = new Map();
  const small = (src) => {
    try { const u = new URL(src, location.href); u.searchParams.set('width', '40'); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.href; } catch (e) { return ''; }
  };
  const ground = (src) => {
    const key = small(src);
    if (!key) return Promise.resolve(null);
    if (cache.has(key)) return cache.get(key);
    const p = new Promise((res) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => {
        try {
          const w = i.naturalWidth, h = i.naturalHeight;
          const c = document.createElement('canvas'); c.width = w; c.height = h;
          const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(i, 0, 0);
          const pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2]].map(([a, b]) => x.getImageData(a, b, 1, 1).data);
          const ch = [0, 1, 2].map((k) => pts.map((q) => q[k]));
          const even = ch.every((v) => Math.max(...v) - Math.min(...v) <= 8);
          const light = ch.every((v) => Math.min(...v) >= 225);
          const opaque = pts.every((q) => q[3] > 250);
          res(even && light && opaque ? 'rgb(' + ch.map((v) => Math.round(v.reduce((s, n) => s + n, 0) / 4)).join(',') + ')' : null);
        } catch (e) { res(null); }
      };
      i.onerror = () => res(null);
      i.src = key;
    });
    cache.set(key, p);
    return p;
  };
  const paint = (box) => {
    if (box.dataset.v2Ground) return;
    const img = box.querySelector('img:not(.v2-card__img--alt)');
    if (!img) return;
    const src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) return;
    box.dataset.v2Ground = '1';
    ground(src).then((col) => {
      if (!col) return;
      box.style.backgroundColor = col;
      box.querySelectorAll('img:not(.v2-card__img--alt)').forEach((im) => { im.style.mixBlendMode = 'normal'; });
    });
  };
  const run = (root) => (root || document).querySelectorAll(SEL).forEach(paint);
  let t;
  const later = () => { clearTimeout(t); t = setTimeout(() => run(), 120); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run()); else run();
  new MutationObserver((m) => { if (m.some((r) => r.addedNodes.length)) later(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
